export default __webpack_public_path__ + "static/media/ads_logo.fec9a72f.fec9a72f.png";